import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { licensesApi } from "../report/services/licenses.api";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initFilter = {
    policy_id: null,
    license_family: null,
    only_violations: false,
};
export const initSort = {
    property: "violations",
    reverse: true,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
    filteredByLink: false,
};
const licensesSlice = createSlice({
    name: "licenses",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        licenseFamilyFiltered: (state, action) => {
            state.filter = { ...initFilter, license_family: action.payload };
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        referencesPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "licenses");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addMatcher(licensesApi.endpoints.getLicenses.matchFulfilled, (state, action) => {
            if (!state.filteredByLink || action.payload.match_count !== 1)
                return;
            state.expandedRows[action.payload.licenses[0].spdx_id] = {
                pagination: initPagination,
            };
            state.focusedRow = action.payload.licenses[0].spdx_id;
        });
    },
});
export const licensesReducer = licensesSlice.reducer;
export const { filterUpdated, licenseFamilyFiltered, sortUpdated, paginationUpdated, referencesPaginationUpdated, expandedRowsUpdated, focusedRowUpdated, } = licensesSlice.actions;
export const selectFilter = (state) => state.report.licenses.filter;
export const selectFilteredByLink = (state) => state.report.licenses.filteredByLink;
export const selectSort = (state) => state.report.licenses.sort;
export const selectPagination = (state) => state.report.licenses.pagination;
export const selectReferencesPagination = (state, id) => { var _a, _b; return (_b = (_a = state.report.licenses.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectFocusedRow = (state) => state.report.licenses.focusedRow;
export const selectExpandedRow = (state, id) => state.report.licenses.expandedRows[id] !== undefined;
export * as default from "./licensesSlice";
//# sourceMappingURL=licensesSlice.js.map